import styled from 'styled-components';
import { Button } from 'antd';
import Color from 'constants/color';

export const ButtonPrimary = styled(Button)`
  background-color: ${Color.primaryNew};
  color: ${Color.white};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0.75em 1.5em;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  &:hover {
    background-color: ${Color.primaryNewHover || Color.primaryNew};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  &:active {
    transform: scale(0.97);
  }

  &:focus {
    outline: none;
    background-color: ${Color.primaryNew};
    border: 1.5px solid ${Color.primaryNew};
    box-shadow: 0 0 0 3px rgba(26, 188, 156, 0.4);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const ButtonPrimaryComment = styled(Button)`
  background: ${Color.primary};
  color: ${Color.darkGray2};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    background: ${Color.primaryNew} !important;
    color: ${Color.white} !important;
    box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
  }
  &:active {
    transition: 0.3s;
    transform: scale(0.95);
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.graySecondary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.graySecondary} !important;
    color: ${Color.white} !important;
    background-color: ${Color.graySecondary} !important;
    box-shadow: none;
  }
`;

export const ButtonDarkGray = styled(Button)`
  background: ${Color.darkGray2};
  color: ${Color.white} !important;
  border: 1.5px solid ${Color.darkGray2} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    background: ${Color.darkGray2} !important;
    border: 1.5px solid ${Color.darkGray2} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    transition: 0.3s;
    transform: scale(0.95);
    border: 1.5px solid ${Color.darkGray2} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.darkGray2} !important;
    border: 1.5px solid ${Color.darkGray2} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }

  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.graySecondary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.graySecondary} !important;
    color: ${Color.white} !important;
    background-color: ${Color.graySecondary} !important;
    box-shadow: none;
  }
`;

export const ButtonOutlineDark = styled(Button)`
  background: ${Color.white} !important;
  color: ${Color.darkGray2} !important;
  border: 1px solid ${Color.darkGray2} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  &:hover {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    /* color: ${Color.black} !important; */
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.darkGray2} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.darkGray2} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.graySecondary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.graySecondary} !important;
    color: ${Color.white} !important;
    background-color: ${Color.graySecondary} !important;
    box-shadow: none;
  }
`;

export const ButtonAddDark = styled(Button)`
  background: ${Color.white} !important;
  color: ${Color.darkGray2} !important;
  border: 1.5px solid ${Color.darkGray2} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.black} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.darkGray2} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
    transition: 0.3s;
    transform: scale(0.95);
  }
  &:focus {
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.darkGray2} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.5;
      background: ${Color.graySecondary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    opacity: 0.5;
    border-color: ${Color.graySecondary} !important;
    color: ${Color.white} !important;
    background-color: ${Color.graySecondary} !important;
    box-shadow: none;
  }
`;

export const ButtonSuccess = styled(Button)`
  cursor: pointer;
  background-color: ${Color.success};
  color: ${Color.white};
  font-weight: 600;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6em 1.5em;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Color.greenGradient};
    box-shadow: 0 4px 12px rgba(32, 201, 151, 0.4);
    color: ${Color.white};
  }

  &:focus {
    outline: none;
    background-color: ${Color.greenGradient2};
    box-shadow: 0 0 0 3px rgba(32, 201, 151, 0.3);
    border: none;
  }

  &:active {
    transform: scale(0.96);
    box-shadow: 0 2px 6px rgba(32, 201, 151, 0.3);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.7;
  }
`;

export const ButtonDelete = styled(Button)`
  cursor: pointer;
  background-color: ${Color.danger};
  color: ${Color.white};
  font-weight: 600;
  border-radius: 8px;
  padding: 0.6em 1.5em;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Color.dangerHover};
    box-shadow: 0 6px 12px rgba(217, 45, 32, 0.25);
    color: ${Color.white};
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    background-color: ${Color.dangerHover};
    box-shadow: 0 0 0 3px rgba(217, 45, 32, 0.3);
  }

  &:active {
    transform: scale(0.95);
    box-shadow: 0 3px 6px rgba(217, 45, 32, 0.2);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
    transform: none;
  }
`;

export const ButtonDeleteOutline = styled(Button)`
  cursor: pointer;
  background-color: ${Color.white};
  color: ${Color.danger};
  font-weight: 600;
  border: 1.5px solid ${Color.danger};
  border-radius: 8px;
  padding: 0.6em 1.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    color: ${Color.white};
    background-color: ${Color.danger};
    border-color: ${Color.danger};
    box-shadow: 0 4px 12px rgba(217, 45, 32, 0.2);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(217, 45, 32, 0.3);
    border-color: ${Color.dangerHover};
  }

  &:active {
    transform: scale(0.96);
    background-color: ${Color.dangerHover};
    border-color: ${Color.dangerHover};
    box-shadow: 0 2px 6px rgba(217, 45, 32, 0.25);
    color: ${Color.white};
  }

  &:disabled {
    background-color: ${Color.white};
    color: ${Color.graySecondary};
    border-color: ${Color.graySecondary};
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }
`;

export const ButtonPrimaryWarning = styled(Button)`
  height: 32px;
  background-color: ${Color.colorWarning};
  color: ${Color.white};
  font-weight: 600;
  border: 1.5px solid ${Color.colorWarning};
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Color.warningHover};
    border-color: ${Color.warningHover};
    box-shadow: 0 4px 10px rgba(248, 189, 38, 0.25);
    color: ${Color.white};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(248, 189, 38, 0.3);
  }

  &:active {
    transform: scale(0.96);
    background-color: ${Color.warningBorderHover};
    border-color: ${Color.warningBorderHover};
    box-shadow: 0 2px 6px rgba(248, 189, 38, 0.3);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    border-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }
`;

export const ButtonOutlineWarning = styled(Button)`
  height: 31.5px;
  background: ${Color.white};
  color: ${Color.colorWarning};
  border: 1.5px solid ${Color.colorWarning} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.darkGray2} !important;
    color: ${Color.darkGray2} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    transition: 0.3s;
    transform: scale(0.95);
    border: 1.5px solid ${Color.darkGray2} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
`;

export const ButtonRevise = styled(Button)`
  background: ${Color.danger};
  color: ${Color.white} !important;
  border: 1.5px solid ${Color.danger} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    background: ${Color.danger} !important;
    border: 1.5px solid ${Color.danger} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    transition: 0.3s;
    transform: scale(0.95);
    border: 1.5px solid ${Color.danger} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.danger} !important;
    border: 1.5px solid ${Color.danger} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.graySecondary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.graySecondary} !important;
    color: ${Color.white} !important;
    background-color: ${Color.graySecondary} !important;
    box-shadow: none;
  }
`;

export const ButtonConfirm = styled(Button)`
  background-color: ${Color.greenDarken1};
  color: ${Color.white};
  font-weight: 600;
  border: 1.5px solid ${Color.greenDarken1};
  border-radius: 6px;
  padding: 0.6em 1.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Color.greenGradient2}; /* เขียวเข้มสวย */
    border-color: ${Color.greenGradient2};
    box-shadow: 0 4px 12px rgba(9, 174, 126, 0.3);
    color: ${Color.white};
  }

  &:focus {
    outline: none;
    background-color: ${Color.greenGradient2};
    border-color: ${Color.greenGradient2};
    box-shadow: 0 0 0 3px rgba(9, 174, 126, 0.3);
  }

  &:active {
    transform: scale(0.96);
    box-shadow: 0 2px 6px rgba(9, 174, 126, 0.25);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    border-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }
`;

export const ButtonApprove = styled(Button)`
  background: ${Color.greenDarken1};
  color: ${Color.white} !important;
  border: 1.5px solid ${Color.greenDarken1} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    background: ${Color.greenDarken1} !important;
    border: 1.5px solid ${Color.greenDarken1} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    transition: 0.3s;
    transform: scale(0.95);
    border: 1.5px solid ${Color.greenDarken1} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.greenDarken1} !important;
    border: 1.5px solid ${Color.greenDarken1} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.graySecondary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.graySecondary} !important;
    color: ${Color.white} !important;
    background-color: ${Color.graySecondary} !important;
    box-shadow: none;
  }
`;

export const ButtonGold = styled(Button)`
  cursor: pointer;
  color: ${Color.white} !important;
  background: ${Color.primaryNew} !important;
  border-color: ${Color.primaryNew} !important;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: ${Color.white} !important;
    border-color: ${Color.primaryNewBorderHover} !important;
    background: ${Color.primaryNewHover} !important;
    filter: brightness(110%);
  }

  &:focus {
    background-color: ${Color.primaryNewHover} !important;
    border-color: ${Color.primaryNewBorderHover} !important;
    box-shadow: 0 0 0 0.25rem ${Color.primaryNewBorderHover} !important;
  }

  &:active {
    &:focus {
      border-color: ${Color.primaryNewBorderHover} !important;
      background: ${Color.primaryNewHover} !important;
      box-shadow: 0 0 0 0.25rem ${Color.primaryNewBorderHover} !important;
    }
    &:hover {
      color: ${Color.white} !important;
      border-color: ${Color.primaryNew} !important;
      background: ${Color.primaryNew} !important;
      filter: brightness(110%);
    }
  }
  &:disabled {
    &:hover {
      opacity: 0.5;
      background: ${Color.blue} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px ${Color.blue} !important;
    }
    cursor: not-allowed;
    opacity: 0.5;
    border-color: ${Color.blue} !important;
    color: ${Color.white} !important;
    background-color: ${Color.blue} !important;
    box-shadow: none;
  }
`;

export const ButtonOutlineGold = styled(Button)`
  background: ${Color.white} !important;
  color: ${Color.primaryNew} !important;
  border: 1px solid ${Color.primaryNew} !important;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.primaryNew} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.primaryNew} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.primaryNew} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.primary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.primaryNew} !important;
    color: ${Color.white} !important;
    background-color: ${Color.primaryNew} !important;
    box-shadow: none;
  }
`;

export const ButtonBlue = styled(Button)`
  cursor: pointer;
  color: ${Color.white} !important;
  background: ${Color.blue} !important;
  border-color: ${Color.blue} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: ${Color.white} !important;
    border-color: ${Color.blueBorderHover} !important;
    background: ${Color.blueHover} !important;
    filter: brightness(110%);
  }

  &:focus {
    background-color: ${Color.blueHover} !important;
    border-color: ${Color.blueBorderHover} !important;
    box-shadow: 0 0 0 0.25rem ${Color.blueBorderHover} !important;
  }

  &:active {
    &:focus {
      border-color: ${Color.blueBorderHover} !important;
      background: ${Color.blueHover} !important;
      box-shadow: 0 0 0 0.25rem ${Color.blueBorderHover} !important;
    }
    &:hover {
      color: ${Color.white} !important;
      border-color: ${Color.blue} !important;
      background: ${Color.blue} !important;
      filter: brightness(110%);
    }
  }
  &:disabled {
    &:hover {
      opacity: 0.5;
      background: ${Color.blue} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px ${Color.blue} !important;
    }
    cursor: not-allowed;
    opacity: 0.5;
    border-color: ${Color.blue} !important;
    color: ${Color.white} !important;
    background-color: ${Color.blue} !important;
    box-shadow: none;
  }
`;

export const ButtonOutlineBlue = styled(Button)`
  background: ${Color.white} !important;
  color: ${Color.blue} !important;
  border: 1px solid ${Color.blue} !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.blue} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.blue} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.blue} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.primary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.blue} !important;
    color: ${Color.white} !important;
    background-color: ${Color.blue} !important;
    box-shadow: none;
  }
`;

export const ButtonPurple = styled(Button)`
  cursor: pointer;
  background-color: ${Color.purple};
  color: ${Color.white};
  font-size: 14px;
  font-weight: 600;
  border: 1.5px solid ${Color.purple};
  border-radius: 6px;
  padding: 0.6em 1.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Color.purpleHover};
    border-color: ${Color.purpleHover};
    box-shadow: 0 4px 12px rgba(155, 48, 255, 0.3); /* แสงม่วง */
    color: ${Color.white};
  }

  &:focus {
    outline: none;
    background-color: ${Color.purpleHover};
    border-color: ${Color.purpleBorderHover};
    box-shadow: 0 0 0 3px rgba(155, 48, 255, 0.25);
  }

  &:active {
    transform: scale(0.96);
    box-shadow: 0 2px 6px rgba(155, 48, 255, 0.25);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    border-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }
`;

export const ButtonOutlinePurple = styled(Button)`
  background: ${Color.white} !important;
  color: ${Color.purple} !important;
  border: 1px solid ${Color.purple} !important;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.purple} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.purple} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.purple} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.primary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.purple} !important;
    color: ${Color.white} !important;
    background-color: ${Color.purple} !important;
    box-shadow: none;
  }
`;

export const ButtonEditOutline = styled(Button)`
  cursor: pointer;
  color: #007482;
  border-color: #007482;
  background: #fff;
  &:hover {
    color: #007482;
    border-color: #007482;
    background: #fff;
    filter: brightness(110%);
  }
  &:focus {
    border-color: #007482;
    background: #fff;
    box-shadow: 0 0 0 0.25rem #00a1b5;
  }
  &:active {
    &:focus {
      border-color: #007482;
      background: #fff;
      box-shadow: 0 0 0 0.25rem #00a1b5;
    }
    &:hover {
      color: #007482;
      border-color: #007482;
      background: #fff;
      filter: brightness(110%);
    }
  }
`;

export const ButtonGreen = styled(Button)`
  cursor: pointer;
  background-color: ${Color.greenDarken1};
  color: ${Color.white};
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6em 1.5em;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Color.successHover}; /* สีเขียวอ่อนขึ้น */
    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3); /* กลมกลืน */
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    background-color: ${Color.successHover};
    box-shadow: 0 0 0 3px rgba(39, 174, 96, 0.35); /* ขอบแบบ soft */
  }

  &:active {
    transform: scale(0.96);
    box-shadow: 0 2px 6px rgba(39, 174, 96, 0.25);
  }

  &:disabled {
    background-color: ${Color.graySecondary};
    color: ${Color.white};
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }
`;

export const ButtonOutlineGreen = styled(Button)`
  background: ${Color.white} !important;
  color: ${Color.greenDarken1} !important;
  border: 1px solid ${Color.greenDarken1} !important;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.greenDarken1} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:active {
    opacity: 0.9;
    transition: 0.5;
    background: ${Color.white} !important;
    color: ${Color.greenDarken1} !important;
    border: 1.5px solid ${Color.black} !important;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.4) !important;
  }
  &:focus {
    background: ${Color.white} !important;
    border: 1.5px solid ${Color.greenDarken1} !important;
    box-shadow: 0 0 0px 0px rgba(0, 0, 0, 0.4) !important;
  }
  &:disabled {
    &:hover {
      opacity: 0.9;
      background: ${Color.primary} !important;
      color: ${Color.white} !important;
      box-shadow: 0 0 10px 1px rgba(255, 255, 255, 0.4) !important;
    }
    cursor: not-allowed;
    border-color: ${Color.greenDarken1} !important;
    color: ${Color.white} !important;
    background-color: ${Color.greenDarken1} !important;
    box-shadow: none;
  }
`;

export const ButtonPremium = styled(Button)`
  cursor: pointer;
  background: linear-gradient(135deg, #0f3e59, #00b894);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 0.6em 1.5em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0c3247, #00a37a);
    box-shadow: 0 4px 12px rgba(0, 184, 148, 0.3);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 184, 148, 0.3);
  }

  &:active {
    transform: scale(0.97);
    box-shadow: 0 2px 6px rgba(0, 184, 148, 0.25);
  }

  &:disabled {
    background-color: #d1e8e2;
    color: #ffffff;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ButtonOutlinePremium = styled(Button)`
  background: white !important;
  color: #00796b !important;
  border: 1.5px solid #00b894 !important;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #e0fcf8 !important;
    box-shadow: 0 0 10px 1px rgba(0, 184, 148, 0.2) !important;
  }

  &:active {
    background: #d1f7ef !important;
    border-color: #00796b !important;
    box-shadow: 0 0 10px 2px rgba(0, 121, 107, 0.3) !important;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(0, 184, 148, 0.3) !important;
  }

  &:disabled {
    background-color: #e5f7f3 !important;
    color: #b0cfc9 !important;
    border-color: #c3e6e0 !important;
    cursor: not-allowed;
  }
`;

// ปุ่มหลักแบบเต็มพื้นหลัง
export const ButtonEmerald = styled(Button)`
  cursor: pointer;
  background: linear-gradient(135deg, #009688, #26a69a);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 0.6em 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #00796b, #1de9b6);
    box-shadow: 0 4px 16px rgba(0, 150, 136, 0.3);
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 150, 136, 0.3);
  }

  &:active {
    transform: scale(0.97);
    box-shadow: 0 2px 6px rgba(0, 150, 136, 0.25);
  }

  &:disabled {
    background-color: #cfeae6;
    color: #ffffff;
    cursor: not-allowed;
    opacity: 0.7;
    box-shadow: none;
  }
`;

// ปุ่มขอบเขียวแบบใหม่ (Outlined Emerald)
export const ButtonOutlineEmerald = styled(Button)`
  background: white !important;
  color: #009688 !important;
  border: 1.5px solid #26a69a !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: #e0f2f1 !important;
    box-shadow: 0 4px 12px rgba(0, 150, 136, 0.2) !important;
  }

  &:active {
    background: #c8ebe7 !important;
    border-color: #00796b !important;
    box-shadow: 0 3px 10px rgba(0, 150, 136, 0.3) !important;
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(0, 150, 136, 0.3) !important;
  }

  &:disabled {
    background: #e0f2f1 !important;
    color: #b2dfdb !important;
    border-color: #b2dfdb !important;
    cursor: not-allowed;
  }
`;
